import apiClient from '@/services/axios'

class CategoriesService {
  constructor() {
    this.$api = apiClient
  }

  categoriesList () {
    return this.$api.get('/admin/categories')
  }

  editCategories(categoryId, payload) {
    if (categoryId)
      return this.$api.put(`/admin/categories/${categoryId}`, payload)
    else
      return this.$api.post('/admin/categories', payload)
  }

  editSubCategories(subCategoryId, payload, parentCategoryId) {
    if (subCategoryId)
      return this.$api.put(`/admin/sub-categories/${subCategoryId}`, payload)
    else
      return this.$api.post(`/admin/categories/${parentCategoryId}/new-sub-category`, payload)
  }

  editSection(sectionId, payload, parentSubCategoryId) {
    if (sectionId)
      return this.$api.put(`/admin/sections/${sectionId}`, payload)
    else
      return this.$api.post(`/admin/sub-categories/${parentSubCategoryId}/new-section`, payload)
  }

  removeCategory(categoryId) {
    return this.$api.delete(`/admin/categories/${categoryId}`)
  }

  removeSubCategory(subCategoryId) {
    return this.$api.delete(`/admin/sub-categories/${subCategoryId}`)
  }

  removeSection(sectionId) {
    return this.$api.delete(`/admin/sections/${sectionId}`)
  }

  fetchAttributeCategories (sectionId) {
    return this.$api.get(`/admin/attributes/categories?section_id=${sectionId}`)
  }

  saveAttributeCategory (payload) {
    if (payload.id)
      return this.$api.put(`/admin/attributes/categories/${payload.id}`, payload)
    else
      return this.$api.post('/admin/attributes/categories', payload)
  }

  deleteAttributeCategory (id) {
    return this.$api.delete(`/admin/attributes/categories/${id}`)
  }
}

export default new CategoriesService()
